import React from "react";
import styled from "styled-components";
import { HomePageDot } from "src/static";

const HERO_IMAGE = "/bg-hero-image.png";

type HeroVisualProps = {
    onClick?: () => void;
    className?: string;
    showDots?: boolean;
};

const HeroVisual = ({ onClick, className, showDots = true }: HeroVisualProps) => {
    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onClick?.();
        }
    };

    return (
        <Wrapper
            className={className}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            aria-label="Explore listings"
        >
            {showDots && <Dots src={HomePageDot} alt="" aria-hidden />}
            <HeroImage src={HERO_IMAGE} alt="ManorAI home search on a laptop" />
        </Wrapper>
    );
};

export default HeroVisual;

const Wrapper = styled.div`
    position: relative;
    width: 100%;
    cursor: pointer;
    user-select: none;

    &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.color.manorleadGold};
        outline-offset: 6px;
        border-radius: 8px;
    }
`;

const Dots = styled.img`
    position: absolute;
    height: 168px;
    top: -72px;
    left: 20%;
    z-index: 0;
    pointer-events: none;
`;

const HeroImage = styled.img`
    position: relative;
    z-index: 1;
    display: block;
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
    transition: transform 0.2s ease;

    ${Wrapper}:hover & {
        transform: translateY(-2px);
    }
`;
